/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { bool, shape, string } from 'prop-types';
import ResponsiveImage from '../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';
import { getDonationsCategory } from '../../../../../../state/ducks/App/App-Selectors';
import { getBrand, getFeatureFlag } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const useStyles = makeStyles((theme) => ({
    passportEligible: {
        padding: '4px 8px',
        marginLeft: '16px',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '3px',
        width: 'fit-content',
        marginBottom: '10px',
        [theme.breakpoints.up('600')]: {
            display: 'inline-flex',
            marginLeft: '24x',
        },
    },
    passportEligibleImage: {
        width: '16px',
        height: '15px',
        marginRight: '6px',
        '& picture': {
            display: 'flex',
        },
        '& img': {
            width: '15px',
            height: '15px',
        },
    },
    passportEligibleContent: {
        fontSize: '16px',
        lineHeight: '17px',
        letterSpacing: '0.5px',
        '@media only screen and (max-width: 640px) and (min-width: 600px) ': {
            fontSize: '15px',
        },
    },
}));
const PassportEligibleImage = ({
    presentationFamily, isPassportBannerEnabled, isPdpRedesignEnabled, passportData,
}) => {
    const classes = useStyles();
    const donationsCategoryName = useSelector(getDonationsCategory);
    const isDeliveryTypeFlag = useSelector(getFeatureFlag('is-delivery-type-pdp-page-data-enabled'));
    const brand = useSelector(getBrand);
    const showPassportContent = presentationFamily === 'flower' && isPassportBannerEnabled && donationsCategoryName?.toLowerCase() !== 'donations';
    if (!showPassportContent && !isPdpRedesignEnabled) return <></>;
    const passportEligibleData = passportData.default_passport_messages?.passport_eligible || {};

    return (
        <div className={classes.passportEligible} style={{ backgroundColor: isDeliveryTypeFlag?.[brand?.domain]?.backgroundColor, color: isDeliveryTypeFlag?.[brand?.domain]?.color }}>
            {passportEligibleData.icon?.url
            && (
                <div className={classes.passportEligibleImage}>
                    <ResponsiveImage
                        path={passportEligibleData.icon.url}
                        alt="Passport Eligible"
                        fullWidth
                    />
                </div>
            )}
            <div className={classes.passportEligibleContent}>{passportEligibleData?.tagline || 'Passport Eligible'}</div>
        </div>
    );
};

PassportEligibleImage.propTypes = {
    isPassportBannerEnabled: bool.isRequired,
    presentationFamily: string.isRequired,
    isPdpRedesignEnabled: bool,
    passportData: shape({
        default_passport_messages: shape({
            passport_eligible: shape({
                icon: string,
                tagline: string,
            }),
        }),
    }),
};
PassportEligibleImage.defaultProps = {
    isPdpRedesignEnabled: false,
    passportData: {},
};

export default PassportEligibleImage;
